<template>
<div :class="{is_fluid:true ? 'container-fluid' : 'container'}">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        is_fluid: {
            type: Boolean,
            default: false,
        }
    }
}
</script>